import React from "react"
import _map from "lodash/map"
import _size from "lodash/size"

import { BOOKING_STAGE_STATUS } from "../constants/common"
import Separator from "./Separator"
import { getBookingStages, getSeparatorColor } from "../utils/common"
import { COLORS } from "../constants/colors"
import Loader from "./Loader"

const getFontIcon = status => {
  if (status === BOOKING_STAGE_STATUS.COMPLETED)
    return (
      <div
        style={{
          width: 20,
          height: 20,
          backgroundColor: COLORS.STATUS_COLORS.SUCCESS,
          borderRadius: 16,
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        <i
          className={"fa fa-check"}
          style={{ color: COLORS.WHITE }}
          aria-hidden="true"
        ></i>
      </div>
    )

  if (status === BOOKING_STAGE_STATUS.IN_PROGRESS) {
    return (
      <div
        style={{
          width: 20,
          height: 20,
          backgroundColor: COLORS.STATUS_COLORS.SUCCESS,
          borderRadius: 16,
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        {/* <i
          className={"fa fa-spinner"}
          style={{ color: COLORS.WHITE }}
          aria-hidden="true"
        ></i> */}
        <Loader
          style={{
            width: 12,
            height: 12,
            border: "1px solid white",
            borderBottomColor: COLORS.STATUS_COLORS.SUCCESS,
          }}
        />
      </div>
    )
  }
  return (
    <div
      style={{
        width: 20,
        height: 20,
        backgroundColor: COLORS.PRIMARY_BORDER_COLOR,
        borderRadius: 16,
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      <i
        className={"fa fa-circle"}
        style={{ color: COLORS.WHITE }}
        aria-hidden="true"
      ></i>
    </div>
  )
}

function BookingTimeline({ status }) {
  const stages = getBookingStages(status)
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {_map(stages, (stage, index) => (
          <p
            key={index}
            style={{
              fontSize: "0.6rem",
              color:
                stage.status === BOOKING_STAGE_STATUS.IN_PROGRESS
                  ? COLORS.TEXT_COLOR_PRIMARY
                  : COLORS.TEXT_COLOR_SECONDARY,
            }}
          >
            {stage.title}
          </p>
        ))}
      </div>
      <div
        style={{
          flexDirection: "row",
          alignItems: "center",
          paddingHorizontal: 16,
          display: "flex",
        }}
      >
        {_map(stages, (stage, index) => {
          const separatorColor = getSeparatorColor(stage.status, index)
          return (
            <React.Fragment key={index}>
              {getFontIcon(stage.status)}
              {index === _size(stages) - 1 ? null : (
                <Separator
                  style={{ flex: 1 }}
                  thickness={2}
                  color={separatorColor}
                />
              )}
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}

export default BookingTimeline
